var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"currentColor","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12.75 10.5v3H9v-3h3.75ZM21 12c0 4.963-4.037 9-9 9s-9-4.037-9-9 4.037-9 9-9 9 4.037 9 9Zm-4.5-2.625-2.25 1.575V9H7.5v6h6.75v-1.95l2.25 1.575v-5.25Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }